import React from 'react';
import AssignmentsResultOverview from './AssignmentsResultOverview';

const AssignmentsResultOverviewContainer = () => <AssignmentsResultOverview />;

export default AssignmentsResultOverviewContainer;
